import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * The query result holds the necessary data that extract from the fetch response.
 */
export var GraphQlQueryResult = /*#__PURE__*/_createClass(function GraphQlQueryResult(code, reason, response) {
  _classCallCheck(this, GraphQlQueryResult);
  this.code = code;
  this.reason = reason;
  this.response = response;
});
var QueryResultCreator = /*#__PURE__*/_createClass(function QueryResultCreator() {
  _classCallCheck(this, QueryResultCreator);
});
/**
 * This class is responsible for creating a query result for a non-OK fetch response.
 */
export var NonOkQueryResultCreator = /*#__PURE__*/function (_QueryResultCreator) {
  _inherits(NonOkQueryResultCreator, _QueryResultCreator);
  var _super = _createSuper(NonOkQueryResultCreator);
  function NonOkQueryResultCreator(fetchResponse) {
    var _this;
    _classCallCheck(this, NonOkQueryResultCreator);
    _this = _super.call(this);
    _this.fetchResponse = fetchResponse;
    return _this;
  }
  _createClass(NonOkQueryResultCreator, [{
    key: "makeQueryResult",
    value: function makeQueryResult() {
      return new GraphQlQueryResult(this.fetchResponse.status, this.fetchResponse.statusText);
    }
  }]);
  return NonOkQueryResultCreator;
}(QueryResultCreator);

/**
 * This class is responsible for creating a query result for a fetch response that contains general errors.
 */
export var GeneralQueryErrorResultCreator = /*#__PURE__*/function (_QueryResultCreator2) {
  _inherits(GeneralQueryErrorResultCreator, _QueryResultCreator2);
  var _super2 = _createSuper(GeneralQueryErrorResultCreator);
  function GeneralQueryErrorResultCreator(errors) {
    var _this2;
    _classCallCheck(this, GeneralQueryErrorResultCreator);
    _this2 = _super2.call(this);
    _this2.errors = errors;
    return _this2;
  }
  _createClass(GeneralQueryErrorResultCreator, [{
    key: "makeQueryResult",
    value: function makeQueryResult() {
      var _this$errors = _slicedToArray(this.errors, 1),
        extensions = _this$errors[0].extensions;
      var _ref = Array.isArray(extensions) ? extensions : [extensions],
        _ref2 = _slicedToArray(_ref, 1),
        _ref2$ = _ref2[0],
        statusCode = _ref2$.statusCode,
        errorType = _ref2$.errorType;
      return new GraphQlQueryResult(statusCode, errorType, {
        errors: this.errors.map(function (error) {
          return error.message;
        })
      });
    }
  }]);
  return GeneralQueryErrorResultCreator;
}(QueryResultCreator);

/**
 * This class is responsible for creating a query result for a fetch response that missing the key attributes.
 */
export var MissingQueryDataResultCreator = /*#__PURE__*/function (_QueryResultCreator3) {
  _inherits(MissingQueryDataResultCreator, _QueryResultCreator3);
  var _super3 = _createSuper(MissingQueryDataResultCreator);
  function MissingQueryDataResultCreator(fetchResponse) {
    var _this3;
    _classCallCheck(this, MissingQueryDataResultCreator);
    _this3 = _super3.call(this);
    _this3.fetchResponse = fetchResponse;
    return _this3;
  }
  _createClass(MissingQueryDataResultCreator, [{
    key: "makeQueryResult",
    value: function makeQueryResult() {
      return new GraphQlQueryResult(this.fetchResponse.status, this.fetchResponse.statusText, {
        errors: ['Received data has missing attributes']
      });
    }
  }]);
  return MissingQueryDataResultCreator;
}(QueryResultCreator);
export var QuerySuccessResultCreator = /*#__PURE__*/function (_QueryResultCreator4) {
  _inherits(QuerySuccessResultCreator, _QueryResultCreator4);
  var _super4 = _createSuper(QuerySuccessResultCreator);
  function QuerySuccessResultCreator(response, data) {
    var _this4;
    _classCallCheck(this, QuerySuccessResultCreator);
    _this4 = _super4.call(this);
    _this4.response = response;
    _this4.data = data;
    return _this4;
  }
  return _createClass(QuerySuccessResultCreator);
}(QueryResultCreator);